// Shared Chakra style prop objects for the transactions admin view. Colors that
// must adapt to color mode are applied in components via useColorModeValue.

/** Table header cell props (Chakra Th). */
export const HEAD_CELL = {
  borderColor: "transparent",
  fontSize: "10px",
  fontWeight: "700",
  letterSpacing: "0.5px",
  py: "12px",
};

/** Table body cell props (Chakra Td). */
export const BODY_CELL = {
  borderColor: "transparent",
  fontSize: "sm",
  py: "10px",
};

/** Key/value summary row props for the approval dialog. */
export const KV_ROW = {
  justify: "space-between",
  gap: "16px",
  py: "8px",
};
